import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { getLanguage } from 'utils/language/language';

const wcm = () => new RxQuery('wcm');

export const getNewTranslation = (date: Date | string) => {
	return wcm().setEndpoint(endpoints.wcm.getNewTranslations(date));
};

export const getRegions = () => {
	return wcm().setEndpoint(endpoints.wcm.addresses.getRegions());
};

export const getCities = () => {
	return wcm().setEndpoint(endpoints.wcm.addresses.getCities());
};

export const getCharities = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.charities)
		.setType('charities');
};

export const getUsageLogos = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.usageLogos())
		.setType('usageLogos');
};

export const getBannedNumbers = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.bannedNumbers)
		.setType('bannedNumbers');
};

export const getInternationalMinutesCountries = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.internationalMinutesCountries)
		.setType('countries');
};

export const getInternationalMinutesDialingCodes = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.internationalMinutesDialingCodes)
		.setType('dialingCodes');
};

export const getImageByPartialPath = (partialPath: string) => {
	const isSVG = String(partialPath).endsWith('svg') || String(partialPath).includes('.svg');
	const rxQuery = wcm()
		.setEndpoint(endpoints.wcm.images.getImageByPartialPath(partialPath))
		.setResponseType('text');
	// for non vector images it should be a blob type but i have no idea how to convert blob to base64 in RN

	// returns url if img is not svg
	return isSVG ? rxQuery.call().pipe(map((r) => r.response)) : of(rxQuery.getParams().fullURL);
};

export const getImagePartialPath = (partialPath: string) => {
	const rxQuery = wcm()
		.setEndpoint(endpoints.wcm.images.getImageByPartialPath(partialPath))
		.setResponseType('text');

	return rxQuery.getParams().fullURL;
};

export const getTopics = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.topics.getTopics(getLanguage()))
		.setType('categories');
};

export const getPostpaidServices = () => {
	return wcm().setEndpoint(endpoints.wcm.shortcuts.getPostpaidServices(getLanguage()));
};

export const getAdminOnTheGoNewServices = () => {
	return wcm().setEndpoint(endpoints.wcm.shortcuts.getAdminOnTheGoNewServices(getLanguage()));
};

export const getTCFBB = () => {
	return wcm().setEndpoint(endpoints.wcm.tcFBB.getTcFBB(getLanguage()));
};

export const getErrorMessages = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.errorMessages)
		.setType('errorMessages');
};

export const getCommitmentsWithBuiltInInternationalAndRoaming = () => {
	return wcm().setEndpoint(endpoints.wcm.commitmentsWithBuiltInInternationalAndRoaming);
};

export const getTariffPlansWithBuiltInInternationalAndRoaming = () => {
	return wcm().setEndpoint(endpoints.wcm.tariffPlansWithBuiltInInternationalAndRoaming);
};

export const getBanks = (language: string) => {
	return wcm()
		.setEndpoint(endpoints.wcm.bankItems.getBankItems(language))
		.setType('bankItems');
};

export const fetchTranslations = (language: string) => {
	return wcm()
		.setEndpoint(endpoints.wcm.fetchTranslations(language))
		.setIsECommerceRequest(); // set withcredentials always false , becuase we dont need authentication tramslation api
};

export const getBOMIntro = (language: string) => {
	return wcm()
		.setEndpoint(endpoints.wcm.getBOMIntro(language))
		.setIsECommerceRequest(); // set withcredentials always false , becuase we dont need authentication tramslation api;
};

export const getUserGuidePDF = (language: string) => {
	return wcm()
		.setEndpoint(endpoints.wcm.getUserGuidePDF(language))
		.setIsECommerceRequest(); // set withcredentials always false , becuase we dont need authentication tramslation api
};

export const getAlerts = () => {
	return wcm().setEndpoint(endpoints.wcm.alerts);
};

export const getWhitelistedCRNumber = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.getWhitelistedCRNumber)
		.disableCache()
		.setIsECommerceRequest(); // set withcredentials always false , becuase we dont need authentication tramslation api
};

export const getConfigurations = () => {
	return wcm()
		.setEndpoint(endpoints.wcm.getConfigurations)
		.disableCache()
		.withErrorHandling()
		.setIsECommerceRequest();
};
